import { render, staticRenderFns } from "./PeopleNo.vue?vue&type=template&id=0119ed3c&scoped=true&"
import script from "./PeopleNo.vue?vue&type=script&lang=js&"
export * from "./PeopleNo.vue?vue&type=script&lang=js&"
import style0 from "./PeopleNo.vue?vue&type=style&index=0&id=0119ed3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119ed3c",
  null
  
)

export default component.exports